import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal" }
const _hoisted_2 = {
  class: "modal fade",
  id: "showDocusignShareDocument",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  class: "modal-dialog modal-dialog-centered modal-dialog-scrollable",
  role: "document"
}
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = {
  key: 0,
  class: "d-block"
}
const _hoisted_7 = {
  key: 0,
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_8 = {
  key: 1,
  class: "absolute-loader-wrap justify-content-center d-flex align-items-center"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_10 = { class: "modal-body" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "bg-light p-3 rounded mb-3" }
const _hoisted_13 = {
  key: 0,
  class: "row"
}
const _hoisted_14 = { class: "border member-list rounded py-2 bg-white mb-2" }
const _hoisted_15 = { class: "member-fig m-1" }
const _hoisted_16 = {
  key: 0,
  class: "badge badge-soft-success"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "fa fa-check-circle" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Filled")
const _hoisted_19 = {
  key: 1,
  class: "badge badge-soft-warning"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "fa fa-hourglass-half" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Pending")
const _hoisted_22 = /*#__PURE__*/_createVNode("h6", null, "Fill Form", -1)
const _hoisted_23 = {
  key: 1,
  class: "bg-light rounded p-3"
}
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "shadowed-card bg-white mb-2 text-center" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "doc-wrap pdf-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-file-pdf" })
], -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("i", { class: "fa fa-download" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Download Pdf ")
const _hoisted_30 = {
  key: 2,
  class: "empty-channel bg-light p-3 mb-3 rounded"
}
const _hoisted_31 = {
  key: 0,
  class: "empty-channel"
}
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "icon-wrapper" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-file-alt" })
], -1)
const _hoisted_33 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_34 = { key: 1 }
const _hoisted_35 = {
  key: 0,
  class: "text-success"
}
const _hoisted_36 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_37 = { key: 2 }
const _hoisted_38 = { class: "modal-footer justify-content-between" }
const _hoisted_39 = {
  key: 0,
  class: "form-sender"
}
const _hoisted_40 = { class: "mb-0" }
const _hoisted_41 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user mr-1" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Sent by : ")
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" on ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            (
              _ctx.docDetails
            )
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  (_ctx.docDetails.name)
                    ? (_openBlock(), _createBlock("h5", _hoisted_7, _toDisplayString(_ctx.docDetails.name), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            ((!_ctx.docDetails.id && !_ctx.docData.status) ||_ctx.state.ui.isPostLoading.clickToRedirect)
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _createVNode("img", {
                    src: 
                  _ctx.state.data.imageBaseUrl
                    ? `${_ctx.state.data.imageBaseUrl}img/loading.gif`
                    : 'img/loading.gif'
                ,
                    alt: ""
                  }, null, 8, ["src"])
                ]))
              : _createCommentVNode("", true),
            _createVNode("button", {
              type: "button",
              class: "close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeDocumentShareModel && _ctx.closeDocumentShareModel(...args))),
              "aria-label": "Close"
            }, [
              _hoisted_9
            ])
          ]),
          _createVNode("div", _hoisted_10, [
            (_ctx.docDetails && _ctx.docDetails.recipients)
              ? (_openBlock(), _createBlock("h6", _hoisted_11, "Sent Users (" + _toDisplayString(_ctx.docDetails.recipients.length) + ")", 1))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_12, [
              (_ctx.docDetails && _ctx.docDetails.recipients)
                ? (_openBlock(), _createBlock("div", _hoisted_13, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.docDetails.recipients, (user, userIndex) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "col-md-6",
                        key: userIndex
                      }, [
                        _createVNode("div", _hoisted_14, [
                          _createVNode("div", _hoisted_15, [
                            (user.image)
                              ? (_openBlock(), _createBlock("img", {
                                  key: 0,
                                  src: user.image,
                                  alt: "",
                                  title: user.email
                                }, null, 8, ["src", "title"]))
                              : (_openBlock(), _createBlock("img", {
                                  key: 1,
                                  src: "https://dummyimage.com/35x35/c9c9c9/363636",
                                  alt: "",
                                  title: user.email
                                }, null, 8, ["title"]))
                          ]),
                          _createVNode("h5", null, _toDisplayString(user.full_name), 1),
                          (user.status == 1)
                            ? (_openBlock(), _createBlock("span", _hoisted_16, [
                                _hoisted_17,
                                _hoisted_18
                              ]))
                            : (_openBlock(), _createBlock("span", _hoisted_19, [
                                _hoisted_20,
                                _hoisted_21
                              ]))
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_22,
            (_ctx.docDetails.status == 'completed')
              ? (_openBlock(), _createBlock("div", _hoisted_23, [
                  _createVNode("div", _hoisted_24, [
                    _createVNode("div", _hoisted_25, [
                      _createVNode("div", _hoisted_26, [
                        _hoisted_27,
                        _createVNode("button", {
                          class: "btn default-btn outline",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.downloadFile(_ctx.docDetails.url)))
                        }, [
                          _hoisted_28,
                          _hoisted_29
                        ])
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_30, [
                  (_ctx.docDetails && _ctx.docDetails.sender)
                    ? (_openBlock(), _createBlock("div", _hoisted_31, [
                        _hoisted_32,
                        (_ctx.state.data.loginUsre==_ctx.docDetails.sender.email)
                          ? (_openBlock(), _createBlock("p", _hoisted_33, " User has not filled the form yet."))
                          : _createCommentVNode("", true),
                        _createVNode("p", null, [
                          _createVNode("a", {
                            href: _ctx.docDetails.url,
                            target: "_blank",
                            class: "btn default-btn mt-3"
                          }, "Preview", 8, ["href"])
                        ]),
                        (_ctx.docData)
                          ? (_openBlock(), _createBlock("span", _hoisted_34, [
                              (_ctx.docData.status == 1)
                                ? (_openBlock(), _createBlock("p", _hoisted_35, " You have already filled."))
                                : _createCommentVNode("", true),
                              (_ctx.docData.status == 0)
                                ? (_openBlock(), _createBlock("p", _hoisted_36, "You have not filled any form."))
                                : _createCommentVNode("", true),
                              (_ctx.docData.status == 0)
                                ? (_openBlock(), _createBlock("p", _hoisted_37, [
                                    _createVNode("a", {
                                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.signDocument(_ctx.docDetails.id))),
                                      class: "btn default-btn mt-3"
                                    }, " Fill Form here")
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
          ]),
          _createVNode("div", _hoisted_38, [
            (_ctx.docDetails && _ctx.docDetails.sender)
              ? (_openBlock(), _createBlock("div", _hoisted_39, [
                  _createVNode("p", _hoisted_40, [
                    _hoisted_41,
                    _hoisted_42,
                    _createVNode("span", null, _toDisplayString(_ctx.docDetails.sender.full_name), 1),
                    _hoisted_43,
                    _createVNode("span", null, _toDisplayString(_ctx.docDetails.sender.created_at), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("button", {
              type: "button",
              class: "btn secondary-btn",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeDocumentShareModel && _ctx.closeDocumentShareModel(...args)))
            }, " Close ")
          ])
        ])
      ])
    ])
  ]))
}